export default {
  title: 'Suspendre la disponibilité',
  description: 'Complet ?',
  pause_availabilities: {
    pause_until_end_of_day: "Suspendre les réservations jusqu'à la fin de la journée ?",
    pause_specific_time: 'Suspendre les réservations pour un autre jour et/ou horaire',
  },
  pause_reservations_today: "Suspendre les réservations aujourd'hui",
  pause_reservations_another_day: 'Suspendre les réservations pour un autre jour',
  paused_availabilities_form: {
    date_time: {
      label: 'Sélectionner une date et une heure',
    },
    reason: {
      label: 'Ajouter une raison (facultatif)',
      placeholder: 'Saisir une description...',
    },
  },
  buttons: {
    save: 'Enregistrer',
  },
  error_messages: {
    creation_failed: "Échec de la création de l'exception",
  },
};
